import { IModel } from '@app/core/interface/model';
import { ModelAttributes } from '@app/core/interface/common';


export class BaseModel<T> implements IModel {
  public attributes: T | ModelAttributes = {};

  public constructor(data: T | ModelAttributes) {
    this.populateAttributes();

    if (data) {
      this.populate(data);
    }
  }

  public populate(data: T | ModelAttributes): void {
    const attributes = Object.keys(data);

    for (const attr of attributes) {
      const value = data[attr];
      if (this.attributes.hasOwnProperty(attr) && value !== null && value !== '') {
        this.attributes[attr] = data[attr];
      }
    }
  }

  public toString(): string {
    return JSON.stringify(this.attributes);
  }

  public toObject(): T | ModelAttributes {
    return this.attributes;
  }

  protected populateAttributes(): void {
    this.attributes = {};
  }
}
